import { CalendarMonth } from "@mui/icons-material";
import { Button, IconButton, Link } from "@mui/joy";
import { format } from "date-fns";
import { FormattedMessage } from "react-intl";

function buildGoogleCalendarUrl(lesson: LinkedLesson): string {
  const title = [lesson.group?.name, "AMANI"].filter(Boolean).join(" — ");

  const startDate = format(new Date(lesson.startDateTime), "yyyyMMdd'T'HHmmss");
  const endDate = format(new Date(lesson.endDateTime), "yyyyMMdd'T'HHmmss");
  const dates = `${startDate}/${endDate}`;

  const location = lesson.group?.branch?.address ?? "";

  const details = [
    lesson.teacher?.appName && `Преподаватель: ${lesson.teacher.appName}`,
    lesson.group?.branch?.name,
    lesson.group?.level,
  ]
    .filter(Boolean)
    .join("\n");

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates,
    location,
    details,
  });

  return `https://www.google.com/calendar/render?${params}`;
}

export function AddToCalendarLink({ lesson }: { lesson: LinkedLesson }) {
  return (
    <Link
      href={buildGoogleCalendarUrl(lesson)}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      onClick={(e) => e.stopPropagation()}
    >
      <IconButton size="sm" variant="plain" color="neutral">
        <CalendarMonth fontSize="small" />
      </IconButton>
    </Link>
  );
}

export function AddToCalendarButton({ lesson }: { lesson: LinkedLesson }) {
  return (
    <Button
      component="a"
      href={buildGoogleCalendarUrl(lesson)}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
      color="neutral"
      size="md"
      startDecorator={<CalendarMonth />}
      sx={{ borderRadius: 0, padding: 2 }}
    >
      <FormattedMessage defaultMessage="Добавить в календарь" />
    </Button>
  );
}
